import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  Comcast,
  Cox,
  Spectrum,
  Optimum,
  Astound,
  WOW,
  TDS,
  BuckeyeBroadband,
  Mediacom,
  ATT,
  BrightspeedV2,
  QuantumFiber,
  CenturyLink,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  Earthlink,
} from 'config/providers';
import { XfinityTheme } from 'config/themes';

// Origin - https://updater.atlassian.net/browse/COREX-1648
export const SatCoXfinity: SingleProviderConfig = {
  name: 'SatCoXfinity',
  micrositeCode: 'SatCoXfinity',
  mainProvider: Comcast,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'xfinityspecial.com',
  homepage: 'https://xfinityspecial.com', // TODO update with path when available
  title: 'Xfinity Authorized Dealer',
  fallbackPhoneNumber: '999-999-9999', // TODO update with real number when available
  fallbackLeadModePhoneNumber: '999-999-9999', // TODO update with real number when available
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: XfinityTheme,
  needsDcSession: false,
  source: 'Xfinity',
  noOffersRetry: 2,
  commercialHomepage: 'https://comcastbusinessspecial.com',
  getCrossSellAction: getDefaultCrossSellAction,
  crossSellProviders: [
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Astound,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    BrightspeedV2,
    QuantumFiber,
    CenturyLink,
    Frontier,
    Windstream,
    CincinnatiBell,
    Verizon,
    Earthlink,
  ],
  movingAppBuyflowUrls: {
    development: 'http://localhost:3000/guest/tvi/buy',
    staging: 'https://staging-cart.xfinityspecial.com/guest/tvi/buy',
    qa: 'https://staging-cart.xfinityspecial.com/guest/tvi/buy',
    production: 'https://cart.xfinityspecial.com/guest/tvi/buy',
  },
  getCheckoutType: asyncEligible,
};
